import $ from "jquery";
export default {
  goTo: (targetDv) => {
    $("html, body").animate(
      {
        scrollTop: $(targetDv).offset().top,
      },
      1000,
    );
  },
};
